import Hero from './components/Hero';
import Features from './components/Features';
import CategoryNav from './components/CategoryNav';
import FeaturedVideos from './components/FeaturedVideos';
import StatsBanner from './components/StatsBanner';
import LatestUpdates from './components/LatestUpdates';
import SpecialTopics from './components/SpecialTopics';
import FAQ from './components/FAQ';

export default function Home() {
  return (
    <>
      <Hero />
      <Features />
      <CategoryNav />
      <FeaturedVideos />
      <StatsBanner />
      <LatestUpdates />
      <SpecialTopics />
      <FAQ />
      {/* JSON-LD Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '蜜桃传媒在线观看',
            url: 'https://www.mitaomedia.com',
            description: '蜜桃传媒在线观看官方入口，提供蜜桃传媒全系列高清视频免费在线播放，无需下载，随时随地畅享蜜桃传媒最新内容。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://www.mitaomedia.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
            publisher: {
              '@type': 'Organization',
              name: '蜜桃传媒',
              url: 'https://www.mitaomedia.com',
              logo: {
                '@type': 'ImageObject',
                url: 'https://readdy.ai/api/search-image?query=Elegant%20peach%20shaped%20media%20company%20logo%20design%2C%20minimalist%20warm%20coral%20tone%2C%20clean%20modern%20brand%20identity%2C%20professional%20streaming%20platform%20icon&width=512&height=512&seq=logo-mitao&orientation=squarish',
              },
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '蜜桃传媒需要下载App才能观看吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '不需要。蜜桃传媒支持在线网页播放，无需下载任何软件或App，打开浏览器即可畅享全部内容。',
                },
              },
              {
                '@type': 'Question',
                name: '蜜桃传媒的视频画质如何？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '蜜桃传媒所有视频均支持高清（720P）、全高清（1080P）和超高清（4K）多种画质选择，系统会根据您的网络状况自动匹配最佳画质。',
                },
              },
              {
                '@type': 'Question',
                name: '蜜桃传媒的内容多久更新一次？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '我们每天都会更新最新内容。热门剧集、综艺节目会在播出后2小时内上线，电影内容也会第一时间跟进。',
                },
              },
              {
                '@type': 'Question',
                name: '蜜桃传媒是否收费？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '蜜桃传媒目前提供大量免费内容供用户观看。部分独家内容可能需要会员权益，我们会始终在内容详情页明确标注。',
                },
              },
              {
                '@type': 'Question',
                name: '在国外可以观看蜜桃传媒吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '可以。蜜桃传媒面向全球用户提供服务，无论您身在何处，只要有网络连接，就可以访问蜜桃传媒观看精彩内容。',
                },
              },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '蜜桃传媒',
            url: 'https://www.mitaomedia.com',
            description: '蜜桃传媒是一家专注于高品质视频内容制作与分发的综合性传媒平台。',
            foundingDate: '2018',
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '400-888-9999',
              contactType: 'customer service',
              email: 'contact@mitaomedia.com',
            },
            address: {
              '@type': 'PostalAddress',
              streetAddress: '传媒文化产业园A座18层',
              addressLocality: '北京',
              addressRegion: '朝阳区',
              addressCountry: 'CN',
            },
          }),
        }}
      />
    </>
  );
}